// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__2PiKJ","gridItem":"styles_gridItem__2DS4c","termsLink":"styles_termsLink__1bozF"};